import React, {Component} from 'react';
import { isEmpty } from 'lodash'
import Currency from '../../commonModules/Currency';
import { Box } from '@material-ui/core';
import { MiniCard, MiniPaper } from '../../commonModules/layouts/CardPage';
import HighChartDouble from '../../commonModules/interface/Charts/HighChartDouble';
import HighChartLine from '../../commonModules/interface/Charts/HighChartLine';

const Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']

const sortByDate = (list) => {
    list.sort((a, b) => {
        a = new Date(a);
        b = new Date(b);
        if (a > b){
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    });
    return list
} 

const getLabels = (date_list) => {
    let new_date_list = []
    date_list.map(date => {
        let label = Months[new Date(date).getMonth()] +" "+ new Date(date).getFullYear()
        if(!new_date_list.includes(label)){
            new_date_list.push(label)
        }
    })
    console.log({new_date_list});
    return new_date_list
}

const calcAveragePayment = (userInfo, nbPeriods) => {
    let average_payment_period = userInfo.periodicity || 0
    let average_payment_amount = (userInfo.totalPayed - userInfo.initialPayment) / (nbPeriods -1) || 0
        
    console.log({
        average_payment_amount,
        nbPeriods,
        average_payment_period,
    });
    return {
        average_payment_amount,
        nbPeriods,
        average_payment_period,
    }
}

const calcDataGeneral = (paymentList, CLIENTS, custom_period = 31, to) => {
	let PAYMENTS = {}
    let ordered_payment_list = paymentList

    // let ordered_payment_list = this.filterDatePayment(paymentList)
    let end_date = to || Date.now()
    const cumulPaymentPrev = []
    const cumulPaymentReal = []
    const cumulLateAmount = []

    const previsional_data = []
    const real_payment_data = []
    const late_amount_data = []

    const bckg_real_data = []
    const bckg_previsional_data = []
    const bckg_late_data = []
    const bckg_late2_data = []

    const prev_payment_object = {} // {"octobre 2018": 16000, septembre:16000}
    const real_payment_object = {} // {"octobre 2018": 16000, septembre:16000}

    let dateLabels = [] // [... "octobre 2018", "septembre 2018"]
    let total_CA = 0
    let totalAmountLate = 0
    let average_month_CA = 0
    
    if(!isEmpty(CLIENTS)){

        const periodicityTS = (custom_period) * 24 * 60 * 60 * 1000 // period entre chaque paiement en millisecondes TS
        const first_payment_date = new Date(ordered_payment_list[0].timePayment)
        const period_since_start = ( end_date - first_payment_date) / periodicityTS
            
        let payment_dates = paymentList.map( pay => {
            let label_payment = Months[new Date(pay.timePayment).getMonth()] +" "+ new Date(pay.timePayment).getFullYear() // "Octobre 2018"
            
            real_payment_object[label_payment] = (real_payment_object[label_payment] || 0) + pay.money // si plusieurs paiements ce mois ci
            total_CA +=  pay.money
			PAYMENTS[pay.paymentID] = pay
            return pay.timePayment
        })
            
        average_month_CA = total_CA / period_since_start
        
        CLIENTS.map( client => {
            // console.log("CLIENT PAYMENTS",client.payments);

            if ( client.payments.length > 0){
				const cPeriodicityTS = (client.periodicity || 31) * 24 * 60 * 60 * 1000
				let first_payment_client = new Date(client.payments[0])    
				// let period_since_start_abo = ( end_date - first_payment_client) / cPeriodicityTS
				const amountAbo = client.abo.total - PAYMENTS[client.payments[0]].money
				// const amountAbo = client.userInfo.totalToPay - client.userInfo.initialPayment
				const mensualite = client.abo.type === "Day" ? client.abo.mensualite : amountAbo

				const prev_nb_payments = amountAbo / mensualite
				const length_abo_daysTS = prev_nb_payments * cPeriodicityTS
			
				const label_end_month = new Date().getMonth()
				const label_end_year = new Date().getFullYear() // last prev 
				// const abo_endTS = first_payment_date.getTime() + length_abo_daysTS
				// const label_end_month = new Date(abo_endTS).getMonth()
				// const label_end_year = new Date(abo_endTS).getFullYear() // last prev 

				console.log('====================================');
				console.log({client, amountAbo, mensualite, prev_nb_payments, length_abo_daysTS, label_end_month, label_end_year});
				console.log('====================================');

              	for (let payIndex = 0; payIndex < Math.ceil( prev_nb_payments ) ; payIndex++){
					let echeance_paiementTS = first_payment_client.getTime() + cPeriodicityTS * payIndex // date paiement dû  TS
					let echeance_paiement_month = Months[new Date(echeance_paiementTS).getMonth()] // MOIS paiement dû
					let label_echeance = echeance_paiement_month +" "+ new Date(echeance_paiementTS).getFullYear() // mois + année paiement dû
				
					// let previsionnal_amount = (payIndex === 0 ? client.initialPayment : client.nextPaymentAmount)
					
					// prev_payment_object[label_echeance] = (prev_payment_object[label_echeance] || 0 ) + previsionnal_amount
						
					if (
						new Date(echeance_paiementTS).getFullYear() < label_end_year || 
						( 
							(new Date(echeance_paiementTS).getFullYear() === label_end_year) &&
							(new Date(echeance_paiementTS).getMonth() <= label_end_month)
						) 
					) {
						prev_payment_object[label_echeance] = (prev_payment_object[label_echeance] || 0 ) + mensualite
					}

					payment_dates.push(echeance_paiementTS)
              	}
            }
        })    
        
        dateLabels = getLabels(sortByDate(payment_dates))
            
        dateLabels.map((date, i) => {
            bckg_real_data.push('rgba(255, 206, 86, 0.6)')// chart color
            bckg_previsional_data.push('rgba(54, 162, 235, 0.6)')// chart color
            bckg_late_data.push('rgba(252, 183, 193, 0.6)')// chart color
            bckg_late2_data.push('rgba(148, 43, 77, 0.6)')// chart color
        
            let prev_amount = prev_payment_object[date] || 0
            let payed_amount = real_payment_object[date] || 0 // montant payé ce mois ou 0 pour periodes sans paiement
            
            real_payment_data[i] = payed_amount
            previsional_data[i] = prev_amount
            if (i === 0){
                cumulPaymentReal[i] = payed_amount
                cumulPaymentPrev[i] = prev_amount
            } else {
                cumulPaymentPrev[i] = cumulPaymentPrev[i-1] + prev_amount      
                cumulPaymentReal[i] = (payed_amount)+ cumulPaymentReal[i-1]
            }
            late_amount_data[i] = prev_amount - payed_amount
            cumulLateAmount[i] = (cumulPaymentPrev[i] - cumulPaymentReal[i])
        })
        
        let totalDiff = cumulPaymentPrev[cumulPaymentPrev.length -1] - cumulPaymentReal[cumulPaymentReal.length -1]
        totalAmountLate = totalDiff > 0 ? totalDiff : 0

        console.log({
            first_payment_date, 
            period_since_start, 
            dateLabels, 
            real_payment_object, 
            prev_payment_object,
            real_payment_data,
            previsional_data,
            cumulPaymentPrev, 
            cumulPaymentReal,
            totalAmountLate,
            total_CA
        });     
    }
        
    return[
        totalAmountLate,
        average_month_CA,
        {
          labels: dateLabels,
          series:[
              {
                  name:'Prévision',
                  data: previsional_data,
                  pointPadding: 0,
                  color: 'rgba(54, 162, 235, 0.6)'// chart color
              },
              {
                  name: 'Réel',
                  data: real_payment_data,
                  pointPadding: 0.3,
                  color: 'rgba(255, 206, 86, 0.8)'// chart color
              },
          ]
      },{
          labels: dateLabels,
          series:[
              {
                  name: 'Prévision',
                  data: cumulPaymentPrev,
                  pointPadding: 0,
                  color: 'rgba(54, 162, 235, 0.6)'// chart color
              },
              {
                  name: 'Réel',
                  data: cumulPaymentReal,
                  pointPadding: 0.3,
                  color: 'rgba(255, 206, 86, 0.6)'// chart color
              },
          ]
      },
    ]
}
export class BarChartGeneral extends Component{
   state = {
        chartData: this.props.chartData
    }
    
    static defaultProps = {
        displayTitle:true,
        displayLegend: true,
        legendPosition:'right',
    }
  
    render(){
        let data = calcDataGeneral(this.props.paymentList, this.props.CLIENTS)
            
        return (
            <MiniPaper
                title={this.props.title}
            >
                <Box p={1}>
					<HighChartDouble
						// title={this.props.title}
						titleY="Montant FCFA"
						type="column"
						categories={data[2].labels}
						series={data[2].series}
						// colors={data.bckg}
						// disableLegend={true}
					/>
                </Box>
            </MiniPaper>
        )
    }
}
export class LineChartGeneral extends Component{
    state = {
        chartData:this.props.chartData
    }
  
    static defaultProps = {
        displayTitle:true,
        displayLegend: true,
        legendPosition:'right',
    }
    render(){
        console.log("LINE CHART ",this.props);
        
        let data = calcDataGeneral(this.props.paymentList, this.props.CLIENTS)

        if(this.props.totalLate){
            this.props.totalLate(data[0])
        }
        return (
            <MiniPaper
                title={this.props.title}
            >
                <Box p={1}>  
                    <HighChartLine 
                        titleY="Montant FCFA"
                        type="column"
                        categories={data[3].labels}
                        series={data[3].series}
                    />
                </Box>
            </MiniPaper>
        )
    }
}




// const calcDataGeneral = (paymentList, CLIENTS, custom_period = 31) => {
//   let ordered_payment_list = paymentList
//   // let objective_ca = 6000000

//   const cumulPaymentPrev = []
//   const cumulPaymentReal = []
//   const cumulLateAmount = []

//   const previsional_data = []
//   const real_payment_data = []
//   const late_amount_data = []

//   const bckg_real_data = []
//   const bckg_previsional_data = []
//   const bckg_late_data = []
//   const bckg_late2_data = []

//   const prev_payment_object = {} // {"octobre 2018": 16000, septembre:16000}
//   const real_payment_object = {} // {"octobre 2018": 16000, septembre:16000}

//   let dateLabels = [] // [... "octobre 2018", "septembre 2018"]
//   let total_CA = 0
//   let totalAmountLate = 0
//   let average_month_CA = 0
  
//   if(!isEmpty(CLIENTS)){

//       // const periodicityTS = (custom_period) * 24 * 60 * 60 * 1000 // period entre chaque paiement en millisecondes TS
//       const first_payment_date = new Date(ordered_payment_list[0].timePayment)
//       const period_since_start = ( Date.now() - first_payment_date)/1000/60/60/24/ (custom_period)
          
//       let payment_dates = paymentList.map( pay => {
          
//           let label_payment = Months[new Date(pay.timePayment).getMonth()] +" "+ new Date(pay.timePayment).getFullYear() // "Octobre 2018"
          
//           real_payment_object[label_payment] = (real_payment_object[label_payment] || 0) + pay.money // si plusieurs paiements ce mois ci
//           total_CA +=  pay.money
      
//           return pay.timePayment
//       })
          
//       average_month_CA = total_CA / period_since_start
      
//       CLIENTS.map( (client, index) => {
//           // console.log("CLIENT PAYMENTS",client.payments);
//           let first_payment_client = new Date(client.payments[0].timePayment)    
//           let period_since_start_abo = ( Date.now() - first_payment_client)/1000/60/60/24/ (client.periodicity)
//           const periodicityTS = (client.periodicity || 31) * 24 * 60 * 60 * 1000
      
//           for (let payIndex = 0; payIndex < period_since_start_abo ; payIndex++){
//               let echeance_paiementTS =  first_payment_client.getTime() + periodicityTS * payIndex // date paiement dû  TS
//               let echeance_paiement_month = Months[new Date(echeance_paiementTS).getMonth()] // MOIS paiement dû
//               let label_echeance = echeance_paiement_month +" "+ new Date(echeance_paiementTS).getFullYear() // mois + année paiement dû
          
//               let previsionnal_amount = (payIndex === 0 ? client.initialPayment : client.nextPaymentAmount)
              
//               prev_payment_object[label_echeance] = (prev_payment_object[label_echeance] || 0 ) + previsionnal_amount
                  
//               payment_dates.push(echeance_paiementTS)
//           }
//       })    
      
//       dateLabels = getLabels(sortByDate(payment_dates))
          
//       dateLabels.map((date, i) => {
//           bckg_real_data.push('rgba(255, 206, 86, 0.6)')// chart color
//           bckg_previsional_data.push('rgba(54, 162, 235, 0.6)')// chart color
//           bckg_late_data.push('rgba(252, 183, 193, 0.6)')// chart color
//           bckg_late2_data.push('rgba(148, 43, 77, 0.6)')// chart color
      
//           let prev_amount = prev_payment_object[date] || 0
//           let payed_amount = real_payment_object[date] || 0 // montant payé ce mois ou 0 pour periodes sans paiement
          
//           real_payment_data[i] = payed_amount
//           previsional_data[i] = prev_amount
//           if (i === 0){
//               cumulPaymentReal[i] = payed_amount
//               cumulPaymentPrev[i] = prev_amount
//           } else {
//               cumulPaymentPrev[i] = cumulPaymentPrev[i-1] + prev_amount      
//               cumulPaymentReal[i] = (payed_amount)+ cumulPaymentReal[i-1]
//           }
//           late_amount_data[i] = prev_amount - payed_amount
//           cumulLateAmount[i] = (cumulPaymentPrev[i] - cumulPaymentReal[i])
//       })
      
//       let totalDiff = cumulPaymentPrev[cumulPaymentPrev.length -1] - cumulPaymentReal[cumulPaymentReal.length -1]
//       totalAmountLate = totalDiff > 0 ? totalDiff : 0

//       console.log({
//           first_payment_date, 
//           period_since_start, 
//           dateLabels, 
//           real_payment_object, 
//           prev_payment_object,
//           real_payment_data,
//           previsional_data,
//           cumulPaymentPrev, 
//           cumulPaymentReal,
//           totalAmountLate,
//           total_CA
//       });     
//   }
      
//   return[
//       {
//           labels: dateLabels,
//           datasets:[
//               {
//                   label:'Réel',
//                   data:real_payment_data,
//                   backgroundColor:bckg_real_data,
//               },
//               // {
//               //   label:'Prévision',
//               //   data:previsional_data,
//               //   backgroundColor:bckg_previsional_data,
//               // },
//               // {
//               //   label:'Impayés',
//               //   data:late_amount_data,
//               //   backgroundColor:bckg_late2_data,
//               // },
//           ]
//       },
//       {
//           labels: dateLabels,
//           datasets:[
//               // {
//               //   label:'Impayés mois',
//               //   data:late_amount_data,
//               //   backgroundColor:bckg_late2_data,
//               // },
//               // {
//               //   label:'Impayés Cumul',
//               //   data:cumulLateAmount,
//               //   backgroundColor:bckg_late_data,
//               // },
//               {
//                   label:'Réel',
//                   data:cumulPaymentReal,
//                   backgroundColor:bckg_real_data,
//               },
//               // {
//               //   label:'Prévision',
//               //   data:cumulPaymentPrev,
//               //   backgroundColor:bckg_previsional_data,
//               // },
//           ]
//       },
//       totalAmountLate,
//       average_month_CA
//   ]
// }